module.exports = __webpack_public_path__ + "img/helper-black.2164a513.svg";